import * as angular from 'angular';
import { IImportResult } from '../../models';

class ImportErrorsListController implements ng.IComponentController {
    errors: IImportResult;
}

angular.module('naut').component('importErrorsList', {
    controller: ImportErrorsListController,
    template: require('./import-errors-list.component.html'),
    bindings: {
        errors: '<'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/inventory/components/import-errors-list/import-errors-list.component.ts